import { ApiProperty } from '@nestjs/swagger';

/**
 * DTO para KPI de Contenedores de la temporada
 */
export class DashboardLinerKpiDto {
  @ApiProperty({
    description: 'Valor del KPI',
    example: 3839,
  })
  valor!: number;

  @ApiProperty({
    description: 'Variación porcentual respecto al período anterior',
    example: 52,
  })
  variacion!: number;
}

/**
 * DTO para KPI de Valor Declarado
 */
export class DashboardLinerVdKpiDto {
  @ApiProperty({
    description: 'Valor en USD',
    example: 9397007,
  })
  valorUsd!: number;

  @ApiProperty({
    description: 'Variación porcentual respecto al período anterior',
    example: 21,
  })
  variacion!: number;
}

/**
 * DTO para KPI de Destinos
 */
export class DashboardLinerDestinosKpiDto {
  @ApiProperty({
    description: 'Cantidad de destinos únicos (POD)',
    example: 59,
  })
  cantidad!: number;

  @ApiProperty({
    description: 'Variación porcentual respecto al período anterior',
    example: 43.9,
  })
  variacion!: number;
}

/**
 * DTO para item de participación por naviera
 */
export class DashboardLinerPartNavieraDto {
  @ApiProperty({
    description: 'Nombre de la naviera',
    example: 'MSC',
  })
  naviera!: string;

  @ApiProperty({
    description: 'Porcentaje de participación',
    example: 51,
  })
  porcentaje!: number;

  @ApiProperty({
    description: 'Cantidad de contenedores',
    example: 1972,
  })
  cntrs!: number;
}

/**
 * DTO para item de participación por tráfico
 */
export class DashboardLinerPartTraficoDto {
  @ApiProperty({
    description: 'Nombre del tráfico',
    example: 'FAR EAST',
  })
  trafico!: string;

  @ApiProperty({
    description: 'Porcentaje de participación',
    example: 54,
  })
  porcentaje!: number;

  @ApiProperty({
    description: 'Cantidad de contenedores',
    example: 2053,
  })
  cntrs!: number;
}

/**
 * DTO para datos mensuales de VD
 */
export class DashboardLinerVdMensualDto {
  @ApiProperty({
    description: 'Mes',
    example: 'NOVIEMBRE',
  })
  mes!: string;

  @ApiProperty({
    description: 'Valor VD en USD',
    example: 4140819,
  })
  valor!: number;

  @ApiProperty({
    description: 'Porcentaje del total',
    example: 44.08,
  })
  porcentaje!: number;
}

/**
 * DTO de respuesta completa del Dashboard Liner
 */
export class DashboardLinerResponseDto {
  @ApiProperty({
    description: 'Bloque de KPIs (contenedores, VD, destinos)',
    example: {
      contenedores: { valor: 3839, variacion: 52 },
      vd: { valorUsd: 9397007, variacion: 21 },
      destinos: { cantidad: 59, variacion: 43.9 },
    },
  })
  kpis!: {
    contenedores: DashboardLinerKpiDto;
    vd: DashboardLinerVdKpiDto;
    destinos: DashboardLinerDestinosKpiDto;
  };

  @ApiProperty({
    description: 'Participación por naviera',
    type: [DashboardLinerPartNavieraDto],
  })
  participacionNaviera!: DashboardLinerPartNavieraDto[];

  @ApiProperty({
    description: 'Participación por tráfico',
    type: [DashboardLinerPartTraficoDto],
  })
  participacionTrafico!: DashboardLinerPartTraficoDto[];

  @ApiProperty({
    description: 'VD por mes de la temporada',
    type: [DashboardLinerVdMensualDto],
  })
  vdPorMes!: DashboardLinerVdMensualDto[];

  @ApiProperty({
    description: 'Información de la temporada consultada',
    example: { temporadaId: 7, temporadaNombre: '2024 - 2025' },
  })
  temporada!: {
    temporadaId: number;
    temporadaNombre: string;
  };
}
